import React, { useContext, useEffect, useState } from "react";
import { HiRefresh } from "react-icons/hi"
import { API } from "../../resources/constants";

// Contexts
import AxiosContext from "../../contexts/axios";

const { USER_MANAGEMENT_AUTH_CAPTCHA } = API

export default function SignIn() {

    const [captcha, setCaptcha] = useState("")
    const { axios } = useContext(AxiosContext)

    useEffect(() => {
        getCaptcha();
    }, []);

    const getCaptcha = () => axios.get(USER_MANAGEMENT_AUTH_CAPTCHA).then((response: { data: string }) => {
        const { data: captcha } = response
        setCaptcha(captcha)
    }).catch( (error: {}) => setCaptcha("") )

    return (
        <div className={'captcha'}>
            <div dangerouslySetInnerHTML={{ __html: captcha }} className={'svg-captcha'} />
            <div className={'reload-captcha'}>
                <HiRefresh onClick={() => getCaptcha()} />
            </div>
        </div>
    )
}
